import { noop } from 'lodash-es';
import { useRouter } from 'next/router';
import { DialogHeader, DialogPanel } from '@zep/ui';
import { BackButton, LoginDialogContent, LoginDialogRoot } from './common/common';
import { LoginEmail } from './email/LoginEmail';
const LoginEmailPageSection = () => {
  const router = useRouter();
  const email = String(router.query.email ?? '');
  const initialCode = String(router.query.t ?? '');
  const redirectUrl = String(router.query.redirectURL ?? '/home/spaces');
  const goBack = () => {
    router.back();
  };
  if (!router.isReady) return null;
  return <LoginDialogRoot open={true} onClose={noop} data-sentry-element="LoginDialogRoot" data-sentry-component="LoginEmailPageSection" data-sentry-source-file="LoginEmailSection.tsx">
      <DialogPanel className="mb-[60px]" data-sentry-element="DialogPanel" data-sentry-source-file="LoginEmailSection.tsx">
        <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="LoginEmailSection.tsx">
          <BackButton onClick={goBack} data-sentry-element="BackButton" data-sentry-source-file="LoginEmailSection.tsx" />
        </DialogHeader>
        <LoginDialogContent className="!pt-px" data-sentry-element="LoginDialogContent" data-sentry-source-file="LoginEmailSection.tsx">
          <LoginEmail email={email} initialCode={initialCode} redirectUrl={redirectUrl} data-sentry-element="LoginEmail" data-sentry-source-file="LoginEmailSection.tsx" />
        </LoginDialogContent>
      </DialogPanel>
    </LoginDialogRoot>;
};
export { LoginEmailPageSection };